import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from 'app/api/services/spinnerService';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Skip the global spinner for endpoints that have their own
    // in-component loading UI (chat typing dots, AI streaming, etc.).
    // Otherwise the page-level spinner blocks the rest of the UI while
    // a long-running request is in-flight.
    const skipSpinner =
      request.url.includes('api.openai.com/v1/responses') ||
      request.url.includes('/api/calendar/assistant/messages') ||
      request.url.includes('/api/roleplay-example/') ||
      // The Sprints / "Mine forløb" list loads its own cards progressively;
      // the page chrome (title, filters, view toggle) is useful immediately,
      // so don't block it behind the full-page spinner.
      request.url.includes('/api/sprints/forUser') ||
      request.url.includes('/api/onboarding/forUser') ||
      request.url.includes('/api/MyTeam/details/') ||
      // Best-effort Vimeo thumbnail lookup for the toolbox video facade.
      request.url.includes('vimeo.com/api/oembed');

    if (!skipSpinner) {
      this.spinnerService.show();
    }
    return next
      .handle(request)
      .pipe(finalize(() => {
        if (!skipSpinner) this.spinnerService.hide();
      }));
  }
}
